export const OPTHINES = {
  voteName: '2019poject/2019expressway',
  mustSearch: 'Button',
  buttonBg: '#d7131b',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: false,
  checkBox: false,
  themeColor: {
    activeBgColor: '#c00000',
    inactiveBgColor: '#fbe1d5',
  },
  hasVoteButton: {
    themeColor: '#d7131b',
    text: '投票',
    textColor: '#fff',
  },
  tickets: {
    textFirst: '票数',
  },
  tabs: [
    {
      tabName: '文明示范站',
      tabPath: '/2019GSD/First',
    },
    {
      tabName: '文明服务岗',
      tabPath: '/2019GSD/Second',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019GSD/Third',
    },
    {
      tabName: '活动说明',
      tabPath: '/2019GSD/Fourth',
    },
  ],
  FirstType: [
    {
      name: '文明服务区',
      id: 9,
    },
    {
      name: '文明加油站',
      id: 10,
    },
    {
      name: '文明收费站',
      id: 11,
    },
    {
      name: '文明执法大队',
      id: 12,
    },
  ],
  healthType: [
    {
      name: '文明保安',
      id: 1,
    },
    {
      name: '文明保洁员',
      id: 2,
    },
    {
      name: '文明加油员',
      id: 3,
    },
    {
      name: '文明收费员',
      id: 4,
    },
    {
      name: '文明售货员',
      id: 5,
    },
    {
      name: '文明养护工',
      id: 6,
    },
    {
      name: '文明执法员',
      id: 7,
    },
    {
      name: '文明志愿者',
      id: 8,
    },
  ],
};
